const c = {
  name: "HandsStarTrek",
  dimensions: { width: 31, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30.9 40" style="enable-background:new 0 0 30.9 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30.2,8.3c-0.6-0.9-1.5-1.5-2.6-1.6c-0.7-0.1-1.4,0-2.1,0.2l0.1-0.6C26,4,24.6,1.9,22.4,1.6
			c-2.2-0.4-4.2,1.1-4.6,3.2l-2,11.3L13.5,3.3c-0.2-1-0.8-2-1.6-2.6c-0.9-0.6-1.9-0.9-3-0.7c-1,0.2-2,0.8-2.6,1.7
			C5.9,2.2,5.7,2.8,5.6,3.4C4.9,3,4.1,2.9,3.3,3.1c-1.1,0.2-2,0.8-2.6,1.6c-0.6,0.9-0.9,2-0.7,3.1L3,24.4V27c0,7.2,5.8,13,13,13
			c7.2,0,13-5.8,13-13v-5.5l1.8-10.3C31,10.2,30.8,9.1,30.2,8.3L30.2,8.3z M19.7,5.1c0.2-1.1,1.2-1.8,2.3-1.6
			c1.1,0.2,1.8,1.2,1.6,2.3l-0.7,4c0,0,0,0,0,0L21,21h-4.1L19.7,5.1L19.7,5.1z M7.9,2.8C8.2,2.4,8.7,2.1,9.2,2
			c0.5-0.1,1.1,0,1.5,0.3c0.4,0.3,0.7,0.8,0.8,1.3l2.7,15.6C13.8,19.1,13.4,19,13,19h-2.8L8.4,8.9L7.9,6.3l-0.3-2
			C7.5,3.8,7.6,3.3,7.9,2.8L7.9,2.8z M2.4,5.8C2.7,5.4,3.1,5.1,3.6,5s1.1,0,1.5,0.3c0.4,0.3,0.7,0.8,0.8,1.3l1.9,10.8L8.1,19H7
			c-1.1,0-2,0.4-2.7,1.1L2,7.4C1.9,6.9,2,6.3,2.4,5.8L2.4,5.8z M28.9,10.9L27,21.2l0,5.8c0,6.1-4.9,11-11,11C9.9,38,5,33.1,5,27v-4
			c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H9v2h4c2.2,0,4-1.8,4-4h8v-2h-2l1.9-10.8c0.2-1.1,1.2-1.8,2.3-1.6
			c0.5,0.1,1,0.4,1.3,0.8C28.8,9.8,28.9,10.4,28.9,10.9L28.9,10.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as HandsStarTrek
};
